import styled, { css } from "styled-components";

export const SidebarWrapper = styled.div`
    position: relative;
    width: 120px;
    height: 100%;
    background-color: var(--theme-color-secondary);
    border-radius: 0 15px 15px 0;
    transition: all ease-in-out 0.4s;

    &.sidebar-open {
        margin-left: 0;
    }

    &.sidebar-close {
        margin-left: -120px;

        @media (max-width: 600px) {
            margin-left: -50px;
        }
    }

    @media (max-width: 600px) {
        width: 50px;
    }
`;

export const SidebarContainer = styled.div`
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: var(--theme-color-secondary);
    border-right: 1px solid var(--table-border-color);
    overflow: auto;
    transition: all ease-in-out 0.4s;

    ${(props) =>
        props?.$isopenfull &&
            css`border-radius: 0 15px 15px 0;`
    }

    .menu {
        width: 100%;
        height: max-content;
        display: flex;
        align-items: center;
        text-align: center;
        color: var(--text-color-primary);
        border-bottom: 1px solid var(--table-border-color);
        padding: 10px 0;
        cursor: pointer;
        transition: all ease-in-out 0.3s;

        &:hover {
            color: var(--theme-color-primary);

            .content p {
                color: var(--theme-color-primary);
            }

            .line {
                background-color: var(--table-border-color);
            }
        }

        &.active {
            .line {
                background-color: var(--theme-color-primary);
            }
            .content p {
                color: var(--theme-color-primary);
            }
        }

        &:last-child {
            border-bottom: 0px;
        }

        .line {
            width: 6px;
            height: 90px;
            background-color: transparent;
            border-radius: 3rem;

            @media (max-width: 600px) {
                width: 4px;
                height: 60px;
            }
        }

        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 5px;
            padding: 5px;

            svg {
                width: 100%;
                max-width: 22px;
                height: 22px;
                background-color: var(--theme-color-primary);
                color: var(--theme-color-white);
                padding: 8px;
                border-radius: 8px;

                @media (max-width: 600px) {
                    max-width: 20px;
                    height: 20px;
                    padding: 6px;
                }
            }
            
            p {
                margin: 0;
                color: var(--text-color-primary);
                font-size: 10px;
                font-weight: 600;
                text-transform: capitalize;
                transition: all ease-in-out 0.3s;

                @media (max-width: 600px) {
                    display: none;
                }
            }
        }
    }
`;

export const SubMenusWrapper = styled.div`
    position: absolute;
    z-index: 9;
    top: 0;
    width: 200px;
    height: 100%;
    background-color: var(--theme-color-secondary);
    overflow: auto;
    border-radius: 0 15px 15px 0;
    transition: all ease-in-out 0.4s;

    &.sidebar-open-full {
        margin-left: 0;
        left: 100%;
    }

    &.sidebar-close-full {
        margin-left: -200px;
        left: 0;
    }

    .sidebar-sub-menus-container {
        padding: 40px 0;

        .submenu {
            display: flex;
            align-items: center;
            color: var(--text-color-primary);
            border-bottom: 1px solid var(--table-border-color);
            gap: 5px;
            cursor: pointer;
            padding: 0 10px;

            &:hover {
                background-color: var(--table-border-color);
            }

            &:last-child {
                border-bottom: 0px;
            }

            &.active {
                background-color: var(--theme-color-primary);
                color: var(--theme-color-white);

                p {
                    color: var(--theme-color-white);
                }
            }

            p {
                font-size: 13px;
                text-transform: capitalize;
                transition: all ease-in-out 0.3s;
            }

            svg {
                width: 16px;
                height: auto;
            }
        }
    }
`;
